import { format, isValid } from 'date-fns';
import { it } from 'date-fns/locale';

/**
 * Formatta una data proveniente dal database (stringa "YYYY-MM-DD" o simili)
 * senza mai lanciare eccezioni. date-fns `format` lancia un RangeError se
 * riceve una data non valida (null, stringa malformata, ...): qui lo evitiamo
 * restituendo un fallback, così un singolo record sporco non rende bianca
 * tutta la dashboard.
 */
export function safeFormatDate(
  value: string | number | Date | null | undefined,
  pattern: string,
  fallback = 'Data non valida'
): string {
  if (value === null || value === undefined || value === '') {
    return fallback;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (!isValid(date)) {
    return fallback;
  }
  try {
    return format(date, pattern, { locale: it });
  } catch {
    return fallback;
  }
}
